import { render } from "./LightBox.vue?vue&type=template&id=fed4b688&ts=true"
import script from "./LightBox.vue?vue&type=script&lang=ts"
export * from "./LightBox.vue?vue&type=script&lang=ts"

import "./style.css?vue&type=style&index=0&lang=css"

import exportComponent from "F:\\agent009\\_work\\569\\s\\sites\\easyestate\\easyestate.front\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__